module.exports = __webpack_public_path__ + "media/iconic/clipboard-9bf14126.svg";